<template>
    <div class="wrapper">
      <div class="animated fadeIn">
      <b-row>
        <b-col>
          <!-- <b-card header="Preview banner">
            <div v-html="replaceTemplateVar" @click.prevent="bannerPreview"></div>
          </b-card> -->
          <b-card header="Edit banner">
            <form action="" method="PATCH" enctype="multipart/form-data" class="uploadImage">
              <div class="form-group">
                <label for="#bannername" class="text-info">Banner Name</label>
                <input type="text" class="form-control" placeholder="Banner Name:" required="required" v-model="bannerName">
                <div class="invalid-feedback d-block" v-show="errors.bannername">{{ errors.bannername }}</div>
              </div>
              <div class="form-group">
                <label for="#campaigns" class="text-info">Select the Campaign</label>
                <select id="campaigns" class="form-control" name="campaign" v-model="campaign" @change="addANewCampaign">
                 <option value="0">Select</option>
                  <option v-for="campaign in campaigns" :key="campaign._id" :value="campaign.code">{{campaign.name}}</option>
                  <option class="special" value="addnew">Add a new Campaign</option>
                </select>
               <div id="error" class="invalid-feedback d-block" v-show="errors.campaign">{{ errors.campaign }}</div>
              </div>
              <div class="form-group">
                <label for="#country" class="text-info">Select Country</label>
                <select id="country" class="form-control" name="country" v-model="country">
                  <option value="0">Select</option>
                  <option v-for="country in countries" :key="country.value" :value="country.value">{{country.name}}</option>
                </select>
                <div class="invalid-feedback d-block" v-show="errors.country">{{ errors.country }}</div>
              </div>
              <div class="form-group">
                <label for="#bookmaker" class="text-info">Select the Bookmaker</label>
                <select id="bookmaker" class="form-control" name="bookmaker" v-model="bookmaker" @change="addANewBookmaker">
                  <option value="0">Select</option>
                  <option v-for="bookmaker in bookmakers" :key="bookmaker._id" :value="bookmaker.code">{{bookmaker.name}}</option>
                  <option class="special" value="addnew">Add a new Bookmaker</option>
                </select>
                <div class="invalid-feedback d-block" v-show="errors.bookmaker">{{ errors.bookmaker }}</div>
              </div>

              <div class="form-group">
                <label for="#bannerurl" class="text-info">Bookmaker URL</label>
                <input type="text" id="bannerurl" class="form-control" placeholder="Banner Url: https://www.bet365.com/dl/~offer?affiliate=" required="required" v-model="bannerUrl">
              </div>

              <div class="form-group">
                <label for="#device" class="text-info">Device:</label>
                <select class="form-control" id="device" required v-model="device">
                  <option value="0">Select</option>
                  <option value="desktop">Desktop</option>
                  <option value="mobile">Mobile</option>
                  <option value="tablet">Tablet</option>
                </select>
                <div class="invalid-feedback d-block" v-show="errors.device">{{ errors.device }}</div>
              </div>
              <div class="form-group" v-if="type === 0">
                <!-- Trigger/Open The Modal -->
                <button id="openMediaGallery" class="form-control btn btn-secondary" @click.prevent="mediaGallery">Choose an image <i class="fas fa-images"></i></button>
                <span v-if="!image" class="appendImageName form-control">No image selected!</span>
                <span v-if="image" class="appendImageName form-control">{{ image }}</span>
                <div class="invalid-feedback d-block" v-show="errors.image">{{ errors.image }}</div>
              </div>
              <div class="form-group">
                <label for="#resolution" class="text-info">Banner Size:</label>
                <select class="form-control" id="resolution" required v-model="size" @change="addANewSize">
                  <option value="0">Select</option>
                  <option v-for="size in sizes" :key="size._id" :value="size.sizevalue">{{ size.sizename}}</option>
                  <option class="special" value="addnew">Add a new Size</option>
                </select>
                <div class="invalid-feedback d-block" v-show="errors.size">{{ errors.size }}</div>
              </div>
              <b-form-group>
                <label for="#resolution" class="text-info">Banner type:</label>
                <b-form-select id="resolution" required v-model="type">
                  <option value="" selected disabled>Select:</option>
                  <option v-for="(name, type) in types" :key="type" :value="parseInt(type)">{{ name }}</option>
                </b-form-select>
                <div class="invalid-feedback d-block" v-if="type === 1 && typeof match === 'undefined'">There is no match in database.</div>
                <div class="invalid-feedback d-block" v-show="errors.type">{{ errors.type }}</div>
              </b-form-group>
              <div class="form-group">
                <label for="#device" class="text-info">HTML:</label>
                <textarea id="bannerhtmlcode" rows="30" cols="50" class="form-control" required="required" v-model="html"></textarea>
                <div class="invalid-feedback d-block" v-show="errors.html">{{ errors.html }}</div>
              </div>
              <div class="form-group">
                <button class="mr-2 preview btn btn-info" @click.prevent="bannerPreview">Preview</button>
                <button id="publish" type="submit" class="mr-2 btn btn-danger" @click.prevent="editBanner(banner._id)">Update</button>
                <button id="similar" type="submit" class="mr-2 btn btn-dark" @click.prevent="createSimilarBanner">Create Similar Banner</button>
                <div class="invalid-feedback d-block" v-show="errors.general">{{ errors.general }}</div>
              </div>
              <template v-if="type === 0">
                <p>Example Html Code: </p>
                <h3>Template valiables :</h3>
                <ul class="list-group">
                  <li class="list-group-item">:language</li>
                  <li class="list-group-item"> :language / will be replaced for example with: "România"</li>
                  <li class="list-group-item"> :uniqueId / will be replaced for example with: "3454vh35j53vjh354h435jvj54j"</li>
                  <li class="list-group-item"> :countryCode / will be replaced for example with: "DE"</li>
                  <li class="list-group-item"> :apiKey / will be replaced for example with: "gfs5ehybetrhre56676v5uv7uv7u"</li>
                  <li class="list-group-item"> :size / will be replaced for example with: "200x300"</li>
                  <li class="list-group-item"> :campaign / will be replaced for example with: "1"</li>
                  <li class="list-group-item"> :bookmaker / will be replaced for example with: "1"</li>
                  <li class="list-group-item"> :device / will be replaced for example with: "mobile"</li>
                  <li class="list-group-item"> :affiliateCode / will be replaced for example with: "325_200"</li>
                  <li class="list-group-item"> :bannerUrl / will be replaced for example with: "http://bet365.com/......."</li>
                  <li class="list-group-item"> :logoBanner / will be replaced for example with: "1.png"</li>
                  <li class="list-group-item"> :backgroundUrl / will be replaced for example with: "/media/banner1.jpg"</li>
                </ul>
                <xmp v-html="XMPhtml"></xmp>
              </template>
              <template v-if="type === 1">
                <h3 class="my-3">Add variables to your template:</h3>
                <ol class="list-group">
                  <li class="list-group-item">:home_name - Place home team name</li>
                  <li class="list-group-item">:away_name - Place away team name</li>
                  <li class="list-group-item">:book1_odds1 - Place odds for the first bookmaker</li>
                  <li class="list-group-item">:book1_oddsX - Place odds for the first bookmaker</li>
                  <li class="list-group-item">:book1_odds2 - Place odds for the first bookmaker</li>
                  <li class="list-group-item">:book2_odds1 - Place odds for the second bookmaker</li>
                  <li class="list-group-item">:book2_oddsX - Place odds for the second bookmaker</li>
                  <li class="list-group-item">:book2_odds2 - Place odds for the second bookmaker</li>
                  <li class="list-group-item">:book3_odds1 - Place odds for the third bookmaker</li>
                  <li class="list-group-item">:book3_oddsX - Place odds for the third bookmaker</li>
                  <li class="list-group-item">:book3_odds2 - Place odds for the third bookmaker</li>
                </ol>
                <br>
                <p>Example of svg template:</p>
                <iframe class="d-block w-100 my-3" :srcdoc="DynamicBannerHtmlExample" frameborder="0"></iframe>
              </template>
             </form>
          </b-card>
          </b-col>
          </b-row>

      <!-- Modals -->
      <add-bookmaker></add-bookmaker>
      <add-campaign></add-campaign>
      <add-a-new-size></add-a-new-size>
      <banner-preview></banner-preview>
      <media-gallery :size="size"></media-gallery>
      <!-- End of Modals -->
</div>
</div>

</template>

<script>
import { Bus } from '@/main'
import AddBookmakerModal from '@/views/modals/AddBookmakerModal'
import AddCampaignModal from '@/views/modals/AddCampaignModal'
import AddNewSizeModal from '@/views/modals/AddNewSizeModal'
import PreviewModal from '@/views/modals/PreviewModal'
import MediaGalleryModal from '@/views/modals/MediaGalleryModal'

import { mapGetters } from 'vuex'
import { collect } from 'collect.js'

export default {

  name: 'Create',
  components: {
    'add-bookmaker': AddBookmakerModal,
    'add-campaign': AddCampaignModal,
    'add-a-new-size': AddNewSizeModal,
    'banner-preview': PreviewModal,
    'media-gallery': MediaGalleryModal
  },
  data () {
    return {
      modalOpen: true,
      bannerName: '',
      campaigns: '',
      campaign: 0,
      country: 0,
      bookmakers: '',
      bookmaker: 0,
      bookmakerUrl: '',
      device: '',
      sizes: '',
      image: '',
      size: 0,
      html: '',
      bannerUrl: '',
      banner: {},
      updateImage: false,
      errors: {},
      match: {},
      type: 0,
      types: {
        0: 'Static',
        1: 'Dynamic'
      }
    }
  },
  methods: {
    getBanner () {
      const id = this.$route.params.id
      this.$http.get(`${this.$api_url}/banner/edit/${id}`).then((banner) => {
        if (banner) {
          this.bannerName = banner.data.bannername
          this.campaign = banner.data.campaign
          this.country = banner.data.country_code
          this.bookmaker = banner.data.bookmaker
          this.bannerUrl = banner.data.bannerurl
          this.size = banner.data.size
          this.html = JSON.parse(banner.data.html).data
          this.device = banner.data.device
          this.banner = banner.data
          this.image = banner.data.image
          this.type = banner.data.type
        }
      })
    },
    addANewBookmaker (event) {
      if (event.target.value === 'addnew') {
        Bus.$emit('modalBookmakersOpened')
        this.$bvModal.show('bookmaker-add')
      }
    },
    addANewCampaign (event) {
      if (event.target.value === 'addnew') {
        Bus.$emit('modalCampaignsOpened')
        this.$bvModal.show('campaign-add')
      }
    },
    addANewSize (event) {
      if (event.target.value === 'addnew') {
        this.$bvModal.show('newsize-add')
      }
    },
    removeImage (image) {
      this.$http.post(`${this.$api_url}/mediagallery/remove/uploads/${image}`).then(() => {
        console.log('image removed')
      }).catch((e) => {
        console.log('Image not found!')
      })
    },
    uploadImage (source, destination, extension) {
      this.$http.post(`${this.$api_url}/mediagallery/copy/${source}/${destination}/${extension}`).then((success) => {
        console.log('image saved')
      }).catch((e) => {
        console.log('Image not saved!')
      })
    },
    editBanner (id) {
      const dateNow = Date.now()
      const formData = new FormData()
      this.errors = {}

      if (this.bannerName) {
        formData.append('name', this.bannerName)
      } else {
        this.errors.bannername = 'Banner name is required!'
      }
      if (this.campaign && this.campaign !== 0) {
        formData.append('campaign', this.campaign)
      } else {
        this.errors.campaign = 'Campaign is required!'
      }
      if (this.bookmaker && this.bookmaker !== 0) {
        formData.append('bookmaker', this.bookmaker)
      } else {
        this.errors.bookmaker = 'Bookmaker is required!'
      }
      if (this.country && this.country !== 0) {
        formData.append('country', this.country)
      } else {
        this.errors.country = 'Country is required!'
      }
      if (this.device && this.device !== 0) {
        formData.append('device', this.device)
      } else {
        this.errors.device = 'Device is required!'
      }
      if (this.size && this.size !== 0) {
        formData.append('size', this.size)
      } else {
        this.errors.size = 'Size is required!'
      }
      if (this.html) {
        formData.append('html', this.html)
      } else {
        this.errors.html = 'HTML code is required!'
      }
      if (this.bannerUrl) {
        formData.append('bannerurl', this.bannerUrl)
      } else {
        this.errors.bannerurl = 'banner url is required!'
      }
      formData.append('type', this.type)

      if (Object.keys(this.errors).length === 0) {
        if (this.banner.slug !== this.generateSlug) {
          this.$http.post(`${this.$api_url}/banner/checkIfSlugExist`, { slug: this.generateSlug }).then((data) => {
            if (data.data.message === 'true') {
              this.errors.slug = 'Duplicate slug found!'
              alert(`Duplicate banner slug found! : ${data.data.record.slug}`)
            } else {
              formData.append('slug', this.generateSlug)
              if (this.image !== this.banner.image) {
                if (this.type === 0) {
                  const image = this.image.split('.')
                  const sourceFile = image[0]
                  const ext = image[1]
                  const destinationFile = `${dateNow}`
                  this.removeImage(this.banner.image)
                  this.uploadImage(sourceFile, destinationFile, ext)
                  formData.append('image', destinationFile + '.' + ext)
                } else {
                  formData.append('image', false)
                }
              }
            }
          }).then(() => {
            if (Object.keys(this.errors).length === 0) {
              this.$http.patch(`${this.$api_url}/banner/edit/${id}`, formData).then((banner) => {
                this.banner = banner.data
                if (banner.data.action) {
                  if (Object.prototype.hasOwnProperty.call(banner.data.action, 'redirect')) {
                    if (banner.data.action.redirect) {
                      if (confirm('Banner updated! Navigate to the manage page?')) {
                        this.$router.push('/banners/manage')
                      } else {
                        this.$router.go()
                      }
                    }
                  }
                }
              })
            }
          })
        } else {
          if (this.image !== this.banner.image) {
            if (this.type === 0) {
              const image = this.image.split('.')
              const sourceFile = image[0]
              const ext = image[1]
              this.removeImage(this.banner.image)
              const destinationFile = `${dateNow}`
              this.uploadImage(sourceFile, destinationFile, ext)
              formData.append('image', destinationFile + '.' + ext)
            } else {
              formData.append('image', false)
            }
          }
          this.$http.patch(`${this.$api_url}/banner/edit/${id}`, formData)
            .then((banner) => {
              this.banner = banner.data
              if (banner.data.action) {
                if (Object.prototype.hasOwnProperty.call(banner.data.action, 'redirect')) {
                  if (banner.data.action.redirect) {
                    if (confirm('Banner updated! Navigate to the manage page?')) {
                      this.$router.push('/banners/manage')
                    } else {
                      this.$router.go()
                    }
                  }
                }
              }
            })
        }
      } else {
        this.errors.general = 'Check the required fields!'
        console.log(this.errors)
      }
    },

    createSimilarBanner () {
      this.$router.push(`/banners/create/similar/${this.banner._id}`)
    },
    getCampaigns () {
      this.$http.get(`${this.$api_url}/campaigns/all`).then((campaigns) => {
        this.campaigns = campaigns.data
      })
    },
    getBookmakers () {
      this.$http.get(`${this.$api_url}/bookmakers/all`).then((bookmakers) => {
        this.bookmakers = bookmakers.data
      })
    },
    getBannerSizes () {
      this.$http.get(`${this.$api_url}/sizes/all`).then((sizes) => {
        this.sizes = sizes.data
      })
    },
    getMediaLibraryImages () {
      // axios.get(`${this.$api_url}/sizes`).then((sizes)=>{
      //     this.sizes = sizes.data;
      // })
    },
    getMatch () {
      this.$http.get(`${this.$api_url}/matches/`).then((res) => {
        if (res.data) {
          this.match = collect(res.data.data).where('draft', false).first()
        }
      })
    },
    bannerPreview () {
      Bus.$emit('previewHtml', this.replaceTemplateVar)
      this.$bvModal.show('banner-preview')
    },
    mediaGallery () {
      this.$bvModal.show('media-gallery')
    }
  },
  computed: {
    ...mapGetters(['countries', 'XMPhtml', 'apiKey', 'DynamicBannerHtmlExample']),
    generateSlug () {
      return `/${this.bookmaker}/:affCode/${this.country}/${this.device}/${this.size}/:apiKey?campaign=${this.campaign}`
    },
    replaceTemplateVar () {
      let htData = this.html
      const source = this.updateImage ? 'media' : 'uploads'
      const image = `${this.$api_url}/../${source}/${this.image}`

      htData = htData.replace(/:backgroundUrl/g, image)

      htData = htData.replace(/:bookmaker/g, `${this.bookmaker}`)

      htData = htData.replace(/:size/g, `${this.size}`)

      htData = htData.replace(/:apiKey/g, `${this.apiKey}`)

      htData = htData.replace(/:campaign/g, `${this.campaign}`)

      htData = htData.replace(/:countryCode/g, `${this.country}`)

      htData = htData.replace(/:logoBanner/g, `${this.$api_url}/../img/${this.bookmaker}.png`)

      htData = htData.replace(/:bannerUrl/g, `${this.bannerurl}:affiliateCode`)

      htData = htData.replace(/:affiliateCode/g, '325_200')

      htData = htData.replace(/:device/g, `${this.device}`)

      htData = htData.replace(/:uniqueId/g, `${this.banner._id}`)

      htData = htData.replace(/:home_name/g, this.match?.home_name)

      htData = htData.replace(/:away_name/g, this.match?.away_name)

      htData = htData.replace(/:book1_odds1/g, this.match?.odds[0]?.odd[0]?._attributes?.value)

      htData = htData.replace(/:book1_oddsX/g, this.match?.odds[0]?.odd[2]?._attributes?.value)

      htData = htData.replace(/:book1_odds2/g, this.match?.odds[0]?.odd[1]?._attributes?.value)

      htData = htData.replace(/:book2_odds1/g, this.match?.odds[1]?.odd[0]?._attributes?.value)

      htData = htData.replace(/:book2_oddsX/g, this.match?.odds[1]?.odd[2]?._attributes?.value)

      htData = htData.replace(/:book2_odds2/g, this.match?.odds[1]?.odd[1]?._attributes?.value)

      htData = htData.replace(/:book3_odds1/g, this.match?.odds[2]?.odd[0]?._attributes?.value)

      htData = htData.replace(/:book3_oddsX/g, this.match?.odds[2]?.odd[2]?._attributes?.value)

      htData = htData.replace(/:book3_odds2/g, this.match?.odds[2]?.odd[1]?._attributes?.value)

      content = content.replace(/:hour/g, this.match?.time)
      content = content.replace(/:date/g, this.match?.date)

      return htData
    }
  },
  created () {
    this.getBanner()
    this.getCampaigns()
    this.getBookmakers()
    this.getBannerSizes()
    this.getMatch()

    Bus.$on('reloadBookmakers', (data) => {
      this.getBookmakers()
      this.bookmaker = data.code
    })
    Bus.$on('reloadCampaigns', (data) => {
      this.getCampaigns()
      this.campaign = data.code
    })
    Bus.$on('reloadBannerSizes', (data) => {
      this.getBannerSizes()
      this.size = data.sizevalue
    })
    Bus.$on('imageSelected', (data) => {
      this.image = data
      this.updateImage = true
      this.$bvModal.hide('media-gallery')
    })
  },
  beforeDestroy () {
    Bus.$off('reloadBookmakers')
    Bus.$off('reloadCampaigns')
    Bus.$off('reloadBannerSizes')
    Bus.$off('imageSelected')
  }
}
</script>

<style scoped>
 xmp {
   overflow: auto;
 }
</style>
